import { MyTaskService } from "@/service/MyTaskService";
import { MyTaskDakokuData } from "@/types/Dakoku";
import { DakokuWhereConditions } from "@/types/MyTask";
import { computed, ref, Ref } from "vue"
/*
 * 承認打刻情報取得一覧
 */
export function useList() {
  let loading = ref(0);
  let isListError = ref(false);

  // 読み込み中か判断する
  const isListLoading = computed(() => {
    return !(loading.value === 0 || isListError.value);
  });

  // 一覧取得
  const getList = async (paramas: DakokuWhereConditions) => {
    const srv = new MyTaskService();
    return await srv.getDakokuSyouninList(paramas);
  }
  const loadList = async (paramas: DakokuWhereConditions, form: Ref<MyTaskDakokuData[]>) => {
    loading.value++;

    const res = await getList(paramas);

    if (res) {
      form.value = res;
    }
    loading.value--;
  };

  return {
    isListLoading,
    isListError,
    getList,
    loadList
  };
}
